<template>
  <div class="flex items-center space-x-4">
    <button
      v-for="option in options"
      :key="option.type"
      @click="setView(option.type)"
      class="flex items-center space-x-3 px-6 py-3 rounded-full border focus:outline-hidden"
      :class="viewType == option.type ? 'text-white bg-blackest border-blackest' : 'text-black border-grey-lighter'"
    >
      <FaIcon :icon="['fas', option.icon]" />
      <span class="capitalize">{{ option.type }} View</span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "ViewType",
  data() {
    return {
      options: [
        { type: "list", icon: "th-list" },
        { type: "grid", icon: "th-large" },
      ],
    }
  },
  computed: {
    ...mapState("filter", { viewType: (store) => store.view }),
  },
  methods: {
    ...mapActions("filter", ["setView"]),
  },
}
</script>
